import type { SetStoreFunction } from 'solid-js/store';

import type { CustomerServiceStoreState } from './useCustomerServiceStore';

// 存储 setStore 函数
let storeSetterFn: SetStoreFunction<CustomerServiceStoreState> | null = null;

export function setupCustomerServiceManager(setStore: SetStoreFunction<CustomerServiceStoreState>) {
  storeSetterFn = setStore;
}

export function openCustomerService(): void {
  if (!storeSetterFn) {
    console.error(
      'CustomerServiceManager: Manager not initialized. Make sure GlobalCustomerServiceDialog is rendered.'
    );
    return;
  }
  storeSetterFn('isOpen', true);
}

export function closeCustomerService(): void {
  if (!storeSetterFn) {
    console.error(
      'CustomerServiceManager: Manager not initialized. Make sure GlobalCustomerServiceDialog is rendered.'
    );
    return;
  }
  storeSetterFn('isOpen', false);
}

export function isCustomerServiceReady(): boolean {
  return storeSetterFn !== null;
}

// 导出便捷对象
export const customerServiceManager = {
  open: openCustomerService,
  close: closeCustomerService,
  isReady: isCustomerServiceReady,
};
